import TourWrapper from './TourWrapper';

export default TourWrapper;
